import { Component, OnInit } from '@angular/core';
import { Idle } from '@ng-idle/core';
@Component({
	selector: 'ea-session-timeout-modal',
	templateUrl: './session-timeout-modal.component.html',
	styleUrls: ['./session-timeout-modal.component.scss']
})
export class SessionTimeoutModalComponent implements OnInit {
	countdown: number;
	minuteOrGreaterPluralMapping: { [key: string]: string } = {
		'=60': 'minute',
		other: 'minutes'
	};
	lessThanMinutePluralMapping: { [key: string]: string } = {
		'=1': 'second',
		other: 'seconds'
	};
	constructor(public readonly idle: Idle) {}

	ngOnInit(): void {
		this.idle.onTimeoutWarning.subscribe((seconds) => {
			this.countdown = seconds;
		});
	}
}
